const getSessionToken = () => {
	return new Promise((resolve, reject) => {
		// Fetch token
		fetch('/session/token')
			.then((res) => res.text())
			.then((data) => {
				resolve(data);
			})
			.catch((err) => {
				console.log(err);
				reject(err);
			});
	});
};

export default getSessionToken;
